import { render, staticRenderFns } from "./Setting800.vue?vue&type=template&id=3786ec5c&scoped=true&"
import script from "./Setting800.vue?vue&type=script&lang=js&"
export * from "./Setting800.vue?vue&type=script&lang=js&"
import style0 from "./Setting800.vue?vue&type=style&index=0&id=3786ec5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3786ec5c",
  null
  
)

export default component.exports